import clsx from 'clsx';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  initialize as initializeTaskPanel,
} from '@/src/reducers/tasks/taskForm/taskForm.actions';

const CreatedTaskItem = ({ taskId, title, actionTypeLabel }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch({ type: 'SET_SCREEN_LOADER', Loading: true });
    dispatch(initializeTaskPanel(taskId)).then(() => {
      $(`#task-details`).modal('show');
      dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
    });
  };

  return (
    <React.Fragment>
      <span className={clsx('tw-text-cfo-black')}> {actionTypeLabel} </span>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <a
        className={clsx(
          'tw-font-brandonTextBold tw-text-cfo-blue-600 tw-underline',
          'hover:!tw-underline hover:tw-text-cfo-blue-600'
        )}
        role="button"
        tabIndex={0}
        onClick={handleClick}
      >
        {title}
      </a>
    </React.Fragment>
  );
};

export default CreatedTaskItem;
